import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ConfigService } from './core/services/autoconfig/config.service';
import { ErrorConfigComponent } from './shared/components/error-config/error-config.component';
import { LoaderComponent } from './shared/components/loader/loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ErrorConfigComponent, LoaderComponent],
  template: `
    @if (configService.errorLoading()) {
      <app-error-config />
    } @else {
      <app-loader />
      <router-outlet />
    }
  `,
})
export class App {
  constructor() {
    const title = inject(Title);
    const configService = inject(ConfigService);

    effect(() => {
      const siglas = configService.siglasSistema();
      if (siglas) title.setTitle(siglas);
    });
  }
  readonly configService = inject(ConfigService);
}
